import { render, staticRenderFns } from "./formColumn.vue?vue&type=template&id=7c3036a2&scoped=true"
import script from "./formColumn.vue?vue&type=script&lang=js"
export * from "./formColumn.vue?vue&type=script&lang=js"
import style0 from "./formColumn.vue?vue&type=style&index=0&id=7c3036a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3036a2",
  null
  
)

export default component.exports